/**
 * URL display helpers.
 *
 * Source citations are shown by host, never by full URL — a register record
 * URL is long, noisy, and the host is the part an analyst actually reads
 * ("ares.gov.cz"). One implementation so every surface strips the same things.
 */

/** The display host of a URL — `www.` stripped, input returned if unparseable. */
export function hostOf(url: string | undefined | null): string {
  if (!url) return ''
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}
